import React, { useEffect } from "react";
import { Container, Row, Col, Tab } from "react-bootstrap";
import HeaderTwo from "../../components/HeaderTwo";
import { BreadcrumbBox } from "../../components/common/Breadcrumb";
import PopularCourse from "./PopularCourse";
import FooterTwo from "../../components/FooterTwo";
import { Styles } from "./styles/club";

function CourseDetails() {
  useEffect(() => {
    const courseButton = document.querySelectorAll(".course-button");
    courseButton.forEach((button) => {
      button.addEventListener("click", () => {
        button.classList.toggle("active");
        const content = button.nextElementSibling;

        if (button.classList.contains("active")) {
          content.className = "course-content show";
          content.style.maxHeight = content.scrollHeight + "px";
        } else {
          content.className = "course-content";
          content.style.maxHeight = "0";
        }
      });
    });
  });

  return (
    <div className="main-wrapper course-details-page">
      {/* Header 2 */}
      <HeaderTwo />

      {/* Breadcroumb */}
      <BreadcrumbBox title="Curriculum" />

      <Styles>
        {/* Course Details */}
        <section className="course-details-area">
          <Container>
            <Row>
              <Col lg="9" md="8" sm="12">
                <div className="course-details-top">
                
                  <div className="course-top-overview">
                    <div className="d-flex overviews">
                    
                    </div>
                  </div>
                  <div className="course-details-banner">
                    <img
                      src={process.env.PUBLIC_URL + `/assets/images/cur.jpg`}
                      alt=""
                      className="img-fluid"
                    />
                  </div>
                  <div className="course-tab-list">
                    <Tab.Container defaultActiveKey="overview">
                      
                      <Tab.Content>
                      
                      <Tab.Pane eventKey="overview" className="curriculum-tab">
  <div className="course-curriculum">
    <h5>Course Curriculum</h5>
    <p>
      The curriculum is thoughtfully structured to provide a well-rounded 
      education from Grade 1 to Grade X, ensuring a strong academic foundation 
      while fostering intellectual, social, emotional, and physical development. 
      It encompasses core subjects such as Mathematics, Science, Social Studies, 
      and Languages, along with essential skills in critical thinking, 
      problem-solving, communication, and digital literacy.
    </p>
  </div>

  <div className="course-element">
    <div className="course-item">
      <h5>Standard I to V</h5>
      <div className="course-content show row">
        <div className="col-md-6">
          <ul className="list-unstyled">
            <li className="d-flex align-items-center">
              <i className="fas fa-book-open me-2 custom-icon"></i> 
              <span className="lecture-title">English Paper</span>
            </li>
            <li className="d-flex align-items-center">
              <i className="fas fa-hand-holding-heart me-2"></i> 
              <span className="lecture-title">Moral Instruction</span>
            </li>
            <li className="d-flex align-items-center">
              <i className="fas fa-globe me-2"></i> 
              <span className="lecture-title">General Knowledge</span>
            </li>
            <li className="d-flex align-items-center">
              <i className="fas fa-running me-2"></i> 
              <span className="lecture-title">Physical Education</span>
            </li>
            <li className="d-flex align-items-center">
              <i className="fas fa-heartbeat me-2"></i> 
              <span className="lecture-title">Health Education</span>
            </li>
          </ul>
        </div>
        <div className="col-md-6">
          <ul className="list-unstyled">
            <li className="d-flex align-items-center">
              <i className="fas fa-landmark me-2"></i> 
              <span className="lecture-title">Social Studies</span>
            </li>
            <li className="d-flex align-items-center">
              <i className="fas fa-square-root-alt me-2"></i> 
              <span className="lecture-title">Mathematics</span>
            </li>
            <li className="d-flex align-items-center">
              <i className="fas fa-desktop me-2"></i> 
              <span className="lecture-title">Computer Science</span>
            </li>
            <li className="d-flex align-items-center">
              <i className="fas fa-paint-brush me-2"></i> 
              <span className="lecture-title">Art & Crafts</span>
            </li>
            <li className="d-flex align-items-center">
              <i className="fas fa-calculator me-2"></i> 
              <span className="lecture-title">Abacus</span>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div className="course-item">
      <h5>Standard VI to X</h5>
      <div className="course-content show row">
        <div className="col-md-6">
          <ul className="list-unstyled">
            <li className="d-flex align-items-center">
              <i className="fas fa-book me-2"></i> 
              <span className="lecture-title">English Paper</span>
            </li>
            <li className="d-flex align-items-center">
              <i className="fas fa-flask me-2"></i> 
              <span className="lecture-title">General Science</span>
            </li>
            <li className="d-flex align-items-center">
              <i className="fas fa-landmark me-2"></i> 
              <span className="lecture-title">Social Studies</span>
            </li>
            <li className="d-flex align-items-center">
              <i className="fas fa-square-root-alt me-2"></i> 
              <span className="lecture-title">Mathematics</span>
            </li>
            <li className="d-flex align-items-center">
              <i className="fas fa-hand-holding-heart me-2"></i> 
              <span className="lecture-title">Moral Instruction</span>
            </li>
          </ul>
        </div>
        <div className="col-md-6">
          <ul className="list-unstyled">
            <li className="d-flex align-items-center">
              <i className="fas fa-globe me-2"></i> 
              <span className="lecture-title">General Knowledge</span>
            </li>
            <li className="d-flex align-items-center">
              <i className="fas fa-heartbeat me-2"></i> 
              <span className="lecture-title">Health Education</span>
            </li>
            <li className="d-flex align-items-center">
              <i className="fas fa-running me-2"></i> 
              <span className="lecture-title">Physical Education</span>
            </li>
            <li className="d-flex align-items-center">
              <i className="fas fa-desktop me-2"></i> 
              <span className="lecture-title">Computer Science</span>
            </li>
            <li className="d-flex align-items-center">
              <i className="fas fa-paint-brush me-2"></i> 
              <span className="lecture-title">Art & Crafts</span>
            </li>
            <li className="d-flex align-items-center">
              <i className="fas fa-calculator me-2"></i> 
              <span className="lecture-title">Abacus</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</Tab.Pane>


                      
                  
                      </Tab.Content>
                    </Tab.Container>
                  </div>
                </div>
              </Col>
              <Col lg="3" md="4" sm="12">
                <div className="single-details-sidbar">
                  <Row>
                    <Col md="12">
                    <div className="course-details-feature">
          <h5 className="title">Curriculum Details</h5>
          <ul className="list-unstyled feature-list">
          <li>
              <i className="las la-calculator"></i> Math:  
              <span> Basic & Advanced</span>
            </li>
            <li>
              <i className="las la-laptop-code"></i> Tech:  
              <span> Computer Science</span>
            </li>
            <li>
              <i className="las la-running"></i> Activities:  
              <span> Sports & Arts</span>
            </li>
            <li>
              <i className="las la-globe"></i> GK:  
              <span> Current Affairs</span>
            </li>
            <li>
              <i className="las la-hand-holding-heart"></i> Ethics:  
              <span> Moral Values</span>
            </li>
            <li>
              <i className="las la-calculator"></i> Abacus: 
              <span> Mental Math</span>
            </li>
            <li>
              <i className="las la-book"></i> Subject:  
              <span> English, Science</span>
            </li>
          </ul>
       
        </div>
                    </Col>
                    <Col md="12">
                      <PopularCourse />
                    </Col>
                    {/* <Col md="12">
                      <CourseTag />
                    </Col> */}
                  </Row>
                </div>
              </Col>
            </Row>
          </Container>
        </section>
      </Styles>

      {/* Footer 2 */}
      <FooterTwo />
    </div>
  );
}

export default CourseDetails;
